/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileDay } from './StoreProfileDay';
import {
    StoreProfileDayFromJSON,
    StoreProfileDayFromJSONTyped,
    StoreProfileDayToJSON,
    StoreProfileDayToJSONTyped,
} from './StoreProfileDay';

/**
 * 
 * @export
 * @interface StoreProfileDetailsOpeningHours
 */
export interface StoreProfileDetailsOpeningHours {
    /**
     * 
     * @type {StoreProfileDay}
     * @memberof StoreProfileDetailsOpeningHours
     */
    monday?: StoreProfileDay;
    /**
     * 
     * @type {StoreProfileDay}
     * @memberof StoreProfileDetailsOpeningHours
     */
    tuesday?: StoreProfileDay;
    /**
     * 
     * @type {StoreProfileDay}
     * @memberof StoreProfileDetailsOpeningHours
     */
    wednesday?: StoreProfileDay;
    /**
     * 
     * @type {StoreProfileDay}
     * @memberof StoreProfileDetailsOpeningHours
     */
    thursday?: StoreProfileDay;
    /**
     * 
     * @type {StoreProfileDay}
     * @memberof StoreProfileDetailsOpeningHours
     */
    friday?: StoreProfileDay;
    /**
     * 
     * @type {StoreProfileDay}
     * @memberof StoreProfileDetailsOpeningHours
     */
    saturday?: StoreProfileDay;
    /**
     * 
     * @type {StoreProfileDay}
     * @memberof StoreProfileDetailsOpeningHours
     */
    sunday?: StoreProfileDay;
}

/**
 * Check if a given object implements the StoreProfileDetailsOpeningHours interface.
 */
export function instanceOfStoreProfileDetailsOpeningHours(value: object): value is StoreProfileDetailsOpeningHours {
    return true;
}

export function StoreProfileDetailsOpeningHoursFromJSON(json: any): StoreProfileDetailsOpeningHours {
    return StoreProfileDetailsOpeningHoursFromJSONTyped(json, false);
}

export function StoreProfileDetailsOpeningHoursFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileDetailsOpeningHours {
    if (json == null) {
        return json;
    }
    return {
        
        'monday': json['monday'] == null ? undefined : StoreProfileDayFromJSON(json['monday']),
        'tuesday': json['tuesday'] == null ? undefined : StoreProfileDayFromJSON(json['tuesday']),
        'wednesday': json['wednesday'] == null ? undefined : StoreProfileDayFromJSON(json['wednesday']),
        'thursday': json['thursday'] == null ? undefined : StoreProfileDayFromJSON(json['thursday']),
        'friday': json['friday'] == null ? undefined : StoreProfileDayFromJSON(json['friday']),
        'saturday': json['saturday'] == null ? undefined : StoreProfileDayFromJSON(json['saturday']),
        'sunday': json['sunday'] == null ? undefined : StoreProfileDayFromJSON(json['sunday']),
    };
}

export function StoreProfileDetailsOpeningHoursToJSON(json: any): StoreProfileDetailsOpeningHours {
    return StoreProfileDetailsOpeningHoursToJSONTyped(json, false);
}

export function StoreProfileDetailsOpeningHoursToJSONTyped(value?: StoreProfileDetailsOpeningHours | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monday': StoreProfileDayToJSON(value['monday']),
        'tuesday': StoreProfileDayToJSON(value['tuesday']),
        'wednesday': StoreProfileDayToJSON(value['wednesday']),
        'thursday': StoreProfileDayToJSON(value['thursday']),
        'friday': StoreProfileDayToJSON(value['friday']),
        'saturday': StoreProfileDayToJSON(value['saturday']),
        'sunday': StoreProfileDayToJSON(value['sunday']),
    };
}

